// extracted by mini-css-extract-plugin
export default {"wrap":"Progress_wrap__oIVZJ","progress":"Progress_progress__DRZ8r","content":"Progress_content__qOhuP"};